import { ref } from 'vue';

const isDark = ref(window.localStorage.getItem('theme') === 'dark');
document.documentElement.classList.toggle('dark', isDark.value);

export default function useTheme() {
  const toggleTheme = () => {
    isDark.value = !isDark.value;
    document.documentElement.classList.toggle('dark', isDark.value);
    window.localStorage.setItem('theme', isDark.value ? 'dark' : 'light');
  };
  return { isDark, toggleTheme };
}
